import LeftBanner from "../../components/LeftColumnBanner";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import "../../components/DetailsModal/detailsModalStyles.css";
import DetailsModal from "../../components/DetailsModal";
import { useSelector } from "react-redux";
import { useTouristDocumentTitle } from "../../lib/useTouristDocumentTitle";

const Packages = (props) => {
	const {
		getPackageBundles,
		passes,
		passesAfterActivation,
		activatePackage,
		t,
		payloadAfterLogIn,
		errorActivePackage,
		handleOpenPayment,
	} = props;
	const [openPackage, setOpenPackage] = useState(false);
	const [modalData, setModalData] = useState(null);
	const [bundles, setBundles] = useState([]);

	const packagesState = useSelector((state) => state.PackagesReducer);
	const paymentState = useSelector((state) => state.PaymentReducer);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	useTouristDocumentTitle();

	useEffect(() => {
		if (Object.keys(payloadAfterLogIn).length !== 0) {
			getPackageBundles();
		}
	}, [payloadAfterLogIn, getPackageBundles]);

	useEffect(() => {
		if (Object.keys(passes).length === 0) return;
		setBundles(
			[...(passes.passesItem || [])].sort((a, b) =>
				isTourist ? Number(a.price) - Number(b.price) : a.id > b.id ? 1 : -1,
			),
		);
	}, [passes, isTourist]);

	const handleClosePackage = () => {
		setOpenPackage(false);
	};

	return (
		<Fragment>
			<div className="wrapper">
				<div className="row row-spacer">
					<LeftBanner />
					<div className="col-xs-6 active main-column-width">
						<div className="searchFilterContainer">
							<div className="box topBox mainContent withContent">
								<span className="sectionTitle">{t("oneLook")}</span>
							</div>
						</div>
						<div className="packageListComponent genericSearchFilterBoxParent withGradient withLargeMargin">
							<span className="packageListTitle">{t("packagesTitle")}</span>
							{packagesState.loading ? (
								<span
									className="loadingSpinner"
									style={{
										display: "block",
										position: "static",
										border: "4px solid #3d5265",
										borderRightColor: "transparent",
										margin: "20px auto",
									}}
								/>
							) : (
								<div className="packageList slick-initialized slick-slider">
									<div className="slick-list draggable">
										<div className="slick-track">
											{bundles &&
												bundles.map((d, index) => (
													<div
														key={index}
														className="packageListItem genericSearchFilterBox slick-slide slick-current slick-active"
													>
														<div className="packageListImage">
															<img
																src={
																	isTourist
																		? "/assets/images/Travelers-Sim_placeholder.jpg"
																		: "/assets/images/placeholder.png"
																}
																alt="placeholder"
															/>
														</div>
														<span className="linearGradient"></span>
														<div className="packageListContent">{d.label}</div>
														<div className="linearGradient"></div>

														<div
															className="packageListPrice"
															onClick={() => {
																if (isTourist && !paymentState.loading) {
																	handleOpenPayment?.({
																		initialStep: 1,
																		initialAmount: Number(d.price),
																	});
																	return;
																}
																setOpenPackage(true);
																setModalData(d);
															}}
														>
															<span>{d.price}€</span>
														</div>
													</div>
												))}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="col-xs-3 left-column-hide"></div>
				</div>
				{openPackage && !isTourist ? (
					<DetailsModal
						errorActivePackage={errorActivePackage}
						passesAfterActivation={passesAfterActivation}
						passes={passes}
						activatePackage={activatePackage}
						bundles={modalData}
						t={t}
						open={openPackage}
						onHide={handleClosePackage}
					/>
				) : null}
			</div>
		</Fragment>
	);
};

export default Packages;
